import ReactSelect from "components/Form/Select/Select";
import rest from "lib/rest";
import React, { useEffect, useState } from "react";
import TagsInput from "react-tagsinput";
import { Button, Col, FormGroup, Input, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import rotas from "services/rotas";
import Swal from "sweetalert2";

const CotacaoDigifarma = ({ onClose, gerarCotacao, produtos, filial_id }) => {

  const initialParams = {
    nomeCotacao:'',
    nomeResponsavel:'',
    fornecedores:[]
  }
  
  const [listaFornecedores, setListaFornecedores] = useState(initialParams);
  const [parametros, setParametros] = useState({});

  useEffect(()=>{
    listarFornecedores();
  },[])

  const listarFornecedores = () =>{
    const url = rotas.fornecedoresPedidos;

    const retorno = rest.get(url);

    retorno.then(ret=>{
      if(ret.success == 'S'){
        let forn = [];

        ret.lista.map(fornecedor=>{
          forn.push({id:fornecedor.fornecedor_id,
                      title:fornecedor.fornecedor,
                      forn_cnpj:fornecedor.forn_cnpj
          })
        })
        setListaFornecedores(forn);
      }
    })
  }

  const onChangeParametros = (e) =>{
    let param = {...parametros};

    param[e.target.name] = (e.target.value.toUpperCase != undefined) ? e.target.value.toUpperCase() : e.target.value;

    setParametros(param);
  }

  const onChangeForn = (e, name) =>{
    let param = {
      type: 'select',
      target: {
        name: name,
        value: e
      }
    }
    onChangeParametros(param);
  }

  const validaCodBarrasVazio = () =>{
    let res = true;
    produtos.map(produto=>{
      if((produto.cod_barras == null) || (produto.cod_barras == '')){
        res = false
      }
    })    
    return(res);
  }

  const preValidacoesCotacao = () =>{
    let valida = validaCodBarrasVazio();
    
    if(valida == false){
      Swal.fire({
        title: "Existem produtos sem código de barras, eles não serão cotados, enviar os demais produtos?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "SIM",
        showLoaderOnConfirm: true,}
      ).then(response=>{
        if(response.isConfirmed){
          gerarCotacaoDigifarma();
        }
      })
    }else{
      gerarCotacaoDigifarma();
    }  
  }

  const gerarCotacaoDigifarma = () =>{

    Swal.fire({
      title: "Confirma o envio da cotação?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "SIM",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        const url = rotas.pedidoCotacaoDigifarma;
        
        let params={
          dadosCotacao:parametros,
          filial_id:filial_id,
          produtos:produtos    
        }

        return rest.post(url, params);
      },
      allowOutsideClick: () => !Swal.isLoading()
    }).then((result) => {
      if (result.isConfirmed) {
        if (result.value.success == 'S') {     
          Swal.fire('Atenção', 'Cotação Enviada com Sucesso!', 'success');
        } else {
          Swal.fire('Atenção', 'Erro ao Enviar a Cotação!', 'warning');
        }
      }
    });

  }


  return (
    <>
      <ModalHeader>Cotação Digifarma</ModalHeader>

      <ModalBody>
        <Row>
          <Col md="6">
            <FormGroup className="">
              {/* <Label for="margem_apurada">Cód Faturamento</Label> */}
              <Input
                name="nomeCotacao"                
                placeholder="Nome da cotação"
                onChange={onChangeParametros}
                defaultValue={parametros.nomeCotacao}                  
              />
            </FormGroup>
          </Col>

          <Col md="6">
            <FormGroup className="">
              {/* <Label for="margem_apurada">Cód Faturamento</Label> */}
              <Input
                name="nomeResponsavel"                
                placeholder="Nome do responsável"
                onChange={onChangeParametros}
                defaultValue={parametros.nomeResponsavel}                
                //defaultValue={calculaMargemApurada()}
              />
            </FormGroup>
          </Col>
        </Row>

        <Row>
          <Col>
            <FormGroup>
              <ReactSelect
                name="fornecedores"
                placeholder="Selecione os fornecedores"
                options={listaFornecedores}
              //defaultValue= {form.fornecedor}
                onChange={(e)=>{onChangeForn(e,'fornecedores')}}
                isMulti
              ></ReactSelect>
            </FormGroup>
          </Col>
        </Row>

        <Row
          // hidden={tags.length > 0 ? false : true}
        >
          <TagsInput
            value={[]}
            disabled={true}
            inputProps={{ placeholder: "" }}
            // onChange={onChangeTag}
            tagProps={{ className: 'react-tagsinput-tag info' }}
          />
        </Row>

      </ModalBody>

      <ModalFooter>
        <Row>
          <Col className="mr-2">
            <Button className="bg-success" onClick={preValidacoesCotacao}>Gerar Cotação</Button>
            <Button className="bg-danger" onClick={onClose}>Fechar</Button>
          </Col>
        </Row>
      </ModalFooter>
    </>
  );
}

export default CotacaoDigifarma;  